module.exports = __webpack_public_path__ + "img/PropagationTestsDetails-min.92877e1f.png";